// .hamburger on click add class "is-active" to .hamburger in vanilla js
document.addEventListener("DOMContentLoaded", function () {
  var hamburger = document.querySelector(".hamburger");
  var menu = document.querySelector("#medihub-menu");

  hamburger.addEventListener("click", function () {
    hamburger.classList.toggle("is-active");
    menu.classList.toggle("is-active");
    // Toggle body scroll
    if (menu.classList.contains("is-active")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  });

  // clicked anywhere outside the menu and hamburger should close the menu
  document.addEventListener("click", function (e) {
    if (!menu.contains(e.target) && !hamburger.contains(e.target)) {
      menu.classList.remove("is-active");
      hamburger.classList.remove("is-active");
      document.body.style.overflow = "";
    }
  });

  // on scroll up add sticky-header class to header, on scroll down remove it
  // add sticky-header class to body as well and calculate the height of the header and add padding-top to body equal to the height of the header
  var lastScrollTop = 0;
  var header = document.querySelector("#shopify-section-medihub-header");
  var headerHeight = header.offsetHeight;

  window.addEventListener(
    "scroll",
    function () {
      // Toggling the mobile menu sets body.style.overflow = "hidden", which
      // removes the scrollbar and can reflow the page enough to clamp
      // window.scrollY back under the 400px threshold below — that fires
      // this handler mid-toggle and strips sticky-header right as
      // #medihub-menu (position:absolute, no explicit top) needs the header
      // to stay position:fixed to anchor itself correctly. Ignore scroll
      // while the menu is open so it can't yank the class out from under it.
      if (menu.classList.contains("is-active")) {
        return;
      }
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      headerHeight = header.offsetHeight;
      // dont do this if we're 400px from the top of the page
      if (scrollTop < 400) {
        header.classList.remove("sticky-header");
        header.classList.remove("hidden-header");
        document.body.classList.remove("sticky-header");
        document.body.style.paddingTop = "";
        return;
      }
      if (scrollTop > lastScrollTop) {
        // downscroll
        header.classList.remove("sticky-header");
        header.classList.add("hidden-header");
        document.body.classList.remove("sticky-header");
        document.body.style.paddingTop = "";
      } else {
        // upscroll
        header.classList.add("sticky-header");
        document.body.classList.add("sticky-header");
        header.classList.remove("hidden-header");
        document.body.style.paddingTop = headerHeight + "px";
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    },
    false,
  );

  // each .nav-has-child on touch tap or hover add class 'show' to itself
  var navHasChild = document.querySelectorAll(".nav-has-child");
  navHasChild.forEach(function (nav) {
    nav.addEventListener("click", function (e) {
      // if we're on desktop, do nothing
      if (window.innerWidth >= 1024) {
        return;
      }
      // dont prevent default if item clicked is a child of .nav-child-menu but remove show class if .nav-child-title is clicked
      if (e.target.closest(".nav-child-menu")) {
        if (e.target.closest(".nav-child-title")) {
          nav.classList.remove("show");
        }
        return;
      }
      e.preventDefault();
      nav.classList.toggle("show");
    });
  });
});

(function () {
  // --- tiny helper: find the next/prev item and scroll so it becomes the first visible one
  function scrollByOneItem(ul, dir /* +1 or -1 */) {
    const items = Array.from(ul.querySelectorAll(":scope > li"));
    if (!items.length) return;

    const currentLeft = ul.scrollLeft;

    // Find the item whose left edge is closest to the current scroll position
    const positions = items.map((li) => li.offsetLeft);
    let idx = 0;
    for (let i = 0; i < positions.length; i++) {
      if (positions[i] <= currentLeft + 2) idx = i;
      else break;
    }

    let targetIdx = idx + dir;
    targetIdx = Math.max(0, Math.min(items.length - 1, targetIdx));

    ul.scrollTo({
      left: items[targetIdx].offsetLeft,
      behavior: "smooth",
    });
  }

  function decorateScrollableList(ul) {
    // prevent double-inject when Algolia re-renders
    if (ul.dataset.chevronsInjected === "1") return;
    ul.dataset.chevronsInjected = "1";

    // You said your UL is horizontal-scroll already — ensure it can scroll
    ul.style.overflowX = ul.style.overflowX || "auto";
    ul.style.scrollBehavior = ul.style.scrollBehavior || "smooth";

    // Wrap UL so we can absolutely-position buttons
    const wrap = document.createElement("div");
    wrap.className = "aa-chevron-wrap";
    wrap.style.position = "relative";

    // Insert wrap before UL, move UL into it
    ul.parentNode.insertBefore(wrap, ul);
    wrap.appendChild(ul);

    // Create buttons
    const btnL = document.createElement("button");
    btnL.type = "button";
    btnL.className = "aa-chevron aa-chevron--left";
    btnL.setAttribute("aria-label", "Scroll left");
    btnL.innerHTML = "‹"; // replace with svg if you want

    const btnR = document.createElement("button");
    btnR.type = "button";
    btnR.className = "aa-chevron aa-chevron--right";
    btnR.setAttribute("aria-label", "Scroll right");
    btnR.innerHTML = "›";

    // Basic inline styles (move to CSS file if you prefer)
    const baseBtnStyle = (btn) => {
      btn.style.position = "absolute";
      btn.style.top = "50%";
      btn.style.transform = "translateY(-50%)";
      btn.style.zIndex = "5";
      btn.style.width = "36px";
      btn.style.height = "36px";
      btn.style.borderRadius = "999px";
      btn.style.border = "1px solid rgba(0,0,0,0.15)";
      btn.style.background = "white";
      btn.style.boxShadow = "0 2px 8px rgba(0,0,0,0.12)";
      btn.style.cursor = "pointer";
      btn.style.display = "grid";
      btn.style.placeItems = "center";
      btn.style.userSelect = "none";
      btn.style.lineHeight = "1";
      btn.style.fontSize = "22px";
    };
    baseBtnStyle(btnL);
    baseBtnStyle(btnR);

    btnL.style.left = "10px";
    btnR.style.right = "10px";

    // Click handlers
    btnL.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollByOneItem(ul, -1);
    });
    btnR.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollByOneItem(ul, +1);
    });

    // Optional: hide left/right when at ends
    function updateDisabled() {
      const max = ul.scrollWidth - ul.clientWidth;
      btnL.disabled = ul.scrollLeft <= 2;
      btnR.disabled = ul.scrollLeft >= max - 2;
      btnL.style.opacity = btnL.disabled ? "0.35" : "1";
      btnR.style.opacity = btnR.disabled ? "0.35" : "1";
      btnL.style.pointerEvents = btnL.disabled ? "none" : "auto";
      btnR.style.pointerEvents = btnR.disabled ? "none" : "auto";
    }
    ul.addEventListener("scroll", updateDisabled, { passive: true });
    window.addEventListener("resize", updateDisabled);
    requestAnimationFrame(updateDisabled);

    wrap.appendChild(btnL);
    wrap.appendChild(btnR);
  }

  function tryDecorate() {
    // Target JUST the products list (recommended)
    const productsUl = document.querySelector("#medihub-flyout-products-list");
    if (productsUl) decorateScrollableList(productsUl);

    // If you truly meant every .aa-List that is horizontal, you could do:
    // document.querySelectorAll(".aa-List").forEach(decorateScrollableList);
  }

  // Run after Algolia initializes (official global event)
  document.addEventListener("algolia.autocomplete.afterInit", function () {
    tryDecorate();

    // Autocomplete re-renders panel content; observe for new lists being inserted
    const obs = new MutationObserver(() => tryDecorate());
    obs.observe(document.body, { childList: true, subtree: true });
  });

  // Fallback if the event doesn’t fire for your setup (won’t hurt)
  document.addEventListener("algolia.hooks.initialize", function () {
    setTimeout(tryDecorate, 0);
  });
})();
